function numberToString(num) {
  return `${num > 9 ? '' : 0}${num}`;
}

function diff(date1, date2) {
  const d = Math.abs(date1.getTime() - date2.getTime());
  return Math.ceil(d / (1000 * 3600 * 24));
}

function firstDay(date) {
  date.setDate(1);
  return date;
}

function round(date) {
  date.setMilliseconds(0);
  date.setSeconds(0);
  date.setMinutes(0);
  date.setHours(0);
  return date;
}

function toString(date, mask) {
  if (!date) {
    return '';
  }
  let value = mask || 'DD.MM.YYYY';
  value = value.replace(/YYYY/g, date.getFullYear()
    .toString());
  value = value.replace(/MM/g, numberToString(date.getMonth() + 1));
  value = value.replace(/YYYY/g, (date.getMonth() + 1).toString());
  value = value.replace(/DD/g, numberToString(date.getDate()));
  value = value.replace(/D/g, date.getDate()
    .toString());
  value = value.replace(/HH/g, numberToString(date.getHours()));
  value = value.replace(/H/g, date.getHours()
    .toString());
  const h = date.getHours() % 12 === 0 ? 12 : date.getHours() % 12;
  value = value.replace(/hh/g, numberToString(h));
  value = value.replace(/h/g, h.toString());
  value = value.replace(/mm/g, numberToString(date.getMinutes()));
  value = value.replace(/m/g, date.getMinutes()
    .toString());
  value = value.replace(/ss/g, numberToString(date.getSeconds()));
  value = value.replace(/s/g, date.getSeconds()
    .toString());
  value = value.replace(/a/g, date.getHours() > 12 ? 'am' : 'pm');
  value = value.replace(/A/g, date.getHours() > 12 ? 'AM' : 'PM');
  return value;
}

function addDay(date, day) {
  date.setDate(date.getDate() + day);
  return date;
}

export default {
  diff,
  firstDay,
  round,
  toString,
  addDay,
};
